import React, { useEffect } from 'react';
import { loadCalendly } from './lib/calendly';
import { REAL_ESTATE_PATH, readAnchor, useRoutePath } from './lib/router';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import Features from './components/Features';
import CaseStudies from './components/CaseStudies';
import CaseStudyPage from './components/CaseStudyPage';
import RealEstatePage from './components/RealEstatePage';
import Videos from './components/Videos';
import Process from './components/Process';
import Integrations from './components/Integrations';
import Testimonials from './components/Testimonials';
import Team from './components/Team';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './index.css';

const HomePage: React.FC = () => (
  <>
    <Hero />
    <Stats />
    <Services />
    <Features />
    <CaseStudies />
    <Videos />
    <Process />
    <Integrations />
    <Testimonials />
    <Team />
    <FAQ />
    <Contact />
  </>
);

const App: React.FC = () => {
  const path = useRoutePath();
  const caseSlug = path.startsWith('/work/') ? path.slice('/work/'.length) : null;

  // Warm up the Calendly popup widget so booking CTAs open instantly.
  useEffect(() => {
    loadCalendly().catch(() => {/* CTAs fall back to a direct link */});
  }, []);

  // A route change starts at the top; returning home to an anchor (`#work`)
  // scrolls there once the home sections have actually mounted.
  useEffect(() => {
    const anchor = path ? '' : readAnchor();
    if (!anchor) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }
    const raf = requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        document.getElementById(anchor)?.scrollIntoView({ block: 'start' });
      })
    );
    return () => cancelAnimationFrame(raf);
  }, [path]);

  return (
    <div className="relative bg-navy-900 min-h-screen text-text-main font-sans antialiased overflow-x-hidden">
      {/* page-wide noise texture */}
      <div className="pointer-events-none fixed inset-0 bg-noise opacity-[0.015] mix-blend-soft-light z-[1]" />
      <Navbar />
      <main className="relative z-[2]">
        {path === REAL_ESTATE_PATH ? (
          <RealEstatePage />
        ) : caseSlug ? (
          <CaseStudyPage slug={caseSlug} />
        ) : (
          <HomePage />
        )}
      </main>
      <Footer />
    </div>
  );
};

export default App;
